function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 52 \\u2013 383",
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 17,
    viewBox: "0 0 4 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 93",
    cx: 2,
    cy: 2,
    r: 2,
    style: {
      fill: "#5b646b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 94",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 6.5)",
    style: {
      fill: "#5b646b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 95",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 13)",
    style: {
      fill: "#5b646b"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPoint);
export default __webpack_public_path__ + "static/media/btnPoint.51103393.svg";
export { ForwardRef as ReactComponent };